/* Sipit launch popup — shows every new browser session until signup */
(function () {
  if (window.SipitLaunchPopup) return;
  if (!document.body || !document.body.classList.contains('template-index')) return;

  var DEFAULT_DELAY = 3000;
  var SUBSCRIBED_KEY = 'sipit_launch_subscribed';
  var SESSION_KEY = 'sipit_launch_session_dismiss';

  function forceShow() {
    try {
      return new URLSearchParams(window.location.search).get('launch_popup') === '1';
    } catch (e) {
      return false;
    }
  }

  function clearLegacyOnceFlags() {
    try {
      [
        'sipit_launch_popup_v1',
        'sipit_launch_popup_v2',
        'sipit_launch_popup_v3',
        'sipit_launch_popup_v4',
        'sipit_launch_popup_v5',
      ].forEach(function (key) {
        localStorage.removeItem(key);
      });
    } catch (e) {}
  }

  function isSubscribed() {
    if (forceShow()) return false;
    try {
      return localStorage.getItem(SUBSCRIBED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSubscribed() {
    if (forceShow()) return;
    try {
      localStorage.setItem(SUBSCRIBED_KEY, '1');
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  }

  function isDismissedThisSession() {
    if (forceShow()) return false;
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markDismissedThisSession() {
    if (forceShow()) return;
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  function ensureMarkup() {
    var existing = document.getElementById('SipitLaunchPopupLayout');
    if (existing) return existing;

    document.querySelectorAll('[data-sipit-launch-popup]').forEach(function (node) {
      if (node.id !== 'SipitLaunchPopupLayout') node.remove();
    });

    var wrap = document.createElement('div');
    wrap.innerHTML =
      '<div class="sipit-shell sipit-launch-popup" id="SipitLaunchPopupLayout" data-sipit-launch-popup data-delay="' +
      DEFAULT_DELAY +
      '" hidden>' +
      '<div class="sipit-launch-popup__backdrop" data-sipit-launch-dismiss tabindex="-1"></div>' +
      '<div class="sipit-launch-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="SipitLaunchPopupLayout-title" aria-describedby="SipitLaunchPopupLayout-body">' +
      '<button type="button" class="sipit-launch-popup__close" data-sipit-launch-dismiss aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
      '<div class="sipit-launch-popup__accent" aria-hidden="true"></div>' +
      '<form method="post" action="/contact#SipitLaunchFormLayout" id="SipitLaunchFormLayout" accept-charset="UTF-8" class="sipit-launch-popup__form">' +
      '<input type="hidden" name="form_type" value="customer" />' +
      '<input type="hidden" name="utf8" value="✓" />' +
      '<input type="hidden" name="contact[tags]" value="launch-waitlist,newsletter">' +
      '<input type="hidden" name="contact[accepts_marketing]" value="true">' +
      '<input type="hidden" name="contact[note]" value="" data-sipit-launch-note>' +
      '<p class="sipit-launch-popup__eyebrow">Coming soon</p>' +
      '<h2 id="SipitLaunchPopupLayout-title">Get 10% off</h2>' +
      '<p id="SipitLaunchPopupLayout-body" class="sipit-launch-popup__text">Drop your email — get 10% off. Phone is optional. Join the list for launches, tips and subscriber-only offers.</p>' +
      '<div class="sipit-launch-popup__fields">' +
      '<label class="sipit-launch-popup__label" for="SipitLaunchPopupLayout-email">Email</label>' +
      '<input id="SipitLaunchPopupLayout-email" class="sipit-launch-popup__input" type="email" name="contact[email]" placeholder="you@email.com" required autocomplete="email">' +
      '<label class="sipit-launch-popup__label" for="SipitLaunchPopupLayout-phone">Phone (optional)</label>' +
      '<input id="SipitLaunchPopupLayout-phone" class="sipit-launch-popup__input" type="tel" name="contact[phone]" placeholder="(555) 123-4567" autocomplete="tel" inputmode="tel" data-sipit-launch-phone>' +
      '</div>' +
      '<button type="submit" class="sipit-launch-popup__submit">Notify me</button>' +
      '<p class="sipit-launch-popup__privacy">We\'ll only use this to tell you when we launch. No spam.</p>' +
      '</form></div></div>';

    var root = wrap.firstElementChild;
    document.body.appendChild(root);
    return root;
  }

  function bind(root) {
    if (!root || root.dataset.sipitLaunchReady === '1') return;
    root.dataset.sipitLaunchReady = '1';

    clearLegacyOnceFlags();

    try {
      if (root.parentElement !== document.body) {
        document.body.appendChild(root);
      }
    } catch (e) {}

    var dialog = root.querySelector('.sipit-launch-popup__dialog');
    var form = root.querySelector('form');
    var phoneInput = root.querySelector('[data-sipit-launch-phone]');
    var noteInput = root.querySelector('[data-sipit-launch-note]');
    var successEl = root.querySelector('[data-sipit-launch-success]');
    var lastFocus = null;
    var openTimer = null;

    function getFocusable() {
      if (!dialog) return [];
      return Array.prototype.slice.call(
        dialog.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
    }

    function openPopup() {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('sipit-launch-popup-open');
      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
        var focusables = getFocusable();
        if (focusables.length) {
          try {
            focusables[0].focus();
          } catch (e) {}
        }
      });
    }

    function closePopup(opts) {
      opts = opts || {};
      root.classList.remove('is-open');
      document.documentElement.classList.remove('sipit-launch-popup-open');
      root.hidden = true;
      if (opts.subscribe) {
        markSubscribed();
      } else if (opts.dismiss !== false) {
        markDismissedThisSession();
      }
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus();
        } catch (e) {}
      }
    }

    root.querySelectorAll('[data-sipit-launch-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup({ dismiss: true, subscribe: !!successEl && el.closest('[data-sipit-launch-success]') });
      });
    });

    document.addEventListener('keydown', function (event) {
      if (root.hidden || !root.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup({ dismiss: true });
      }
    });

    if (form && phoneInput && noteInput) {
      form.addEventListener('submit', function () {
        var phone = (phoneInput.value || '').trim();
        noteInput.value = phone ? 'Launch waitlist SMS: ' + phone : 'Launch waitlist signup';
      });
    }

    if (successEl) {
      markSubscribed();
      var discountCode = (root.getAttribute('data-signup-discount-code') || window.SIPIT_SIGNUP_DISCOUNT_CODE || '').trim();
      if (discountCode && window.SipitSignupDiscount) {
        window.SipitSignupDiscount.apply(discountCode);
      }
      openPopup();
      return;
    }

    if (isSubscribed() || isDismissedThisSession()) return;

    var delay = parseInt(root.getAttribute('data-delay') || String(DEFAULT_DELAY), 10);
    if (isNaN(delay) || delay < 0) delay = DEFAULT_DELAY;
    openTimer = window.setTimeout(openPopup, forceShow() ? 0 : delay);
  }

  function boot() {
    clearLegacyOnceFlags();
    if (isSubscribed() && !forceShow()) return;
    var root = document.getElementById('SipitLaunchPopupLayout') || ensureMarkup();
    bind(root);
  }

  window.SipitLaunchPopup = {
    bind: bind,
    boot: boot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
